import { render, staticRenderFns } from "./BundleBreakdownModal.vue?vue&type=template&id=0b6d9d7c&"
import script from "./BundleBreakdownModal.vue?vue&type=script&lang=ts&"
export * from "./BundleBreakdownModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports